// src/js/components/Evaluation/ModuleIntroduction.js
import React, { Component } from "react";
import { connect } from "react-redux";
import renderHTML from "react-render-html";
import {moduleClick} from "../../actions";

const mapStateToProps = state => {
    return {
        modules: state.data.questionnaire.modules,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        moduleClick: payload => dispatch(moduleClick(payload))
    };
}

class ConnectedModuleIntroduction extends Component {
    componentDidMount() {
        const el = document.getElementById('module_'+this.props.module);
        setTimeout(() =>
            el.scrollIntoView({behavior: "smooth", block: "start", inline: "start"})
            , 100
        );
    }

    render() {

        const thismodule = this.props.modules[this.props.module];
        const modulenumber = parseInt(this.props.module,10) + 1;
        const totalmodules = this.props.modules.length;

        return(
            <div className="evModuleContainer" id={`module_${this.props.module}`}>
                <div className="evModuleTitleContainer">
                    <div className="evModuleTitle">
                        {renderHTML(thismodule.heading)}
                    </div>
                    <div className="evModuleQuestions">
                        Module {modulenumber} of {totalmodules}<br/>
                        {thismodule.totalquestions} Questions
                    </div>
                    <div className="evModuleClear"></div>
                </div>
                <div className="evModuleContent">
                    {renderHTML(thismodule.content)}
                </div>
                <div className="evButtonContainer">
                    <span className="evIntroButton" onClick={(e) => this.props.moduleClick(this.props.module)}>Answer the questions &gt;</span>
                </div>
            </div>
        )
    }
}
const ModuleIntroduction = connect(mapStateToProps,mapDispatchToProps)(ConnectedModuleIntroduction);

export default ModuleIntroduction;